module.exports = __webpack_public_path__ + "static/media/sign-in-asset3.61d8f405.svg";